module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.saveReq
    }
  }), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.getReq,
      "message404": "Unable to load settings"
    }
  }), _vm._v(" "), (_vm.getReq.status === 404) ? [_c('v-card-text', [_vm._v("\n      Unable to load settings.\n      You might not have permission to edit these settings.\n      You need to be an owner in order edit settings\n    ")]), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]) : _vm._e()], 1)] : [(_vm.settings && _vm.settings.id) ? _c('v-card-text', [
    [_c('v-list', {
      staticClass: "elevation-5 pa-0"
    }, [_c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.uploadLogo = true
        }
      }
    }, [_c('v-list-tile-avatar', [(_vm.resizedLogoPicture) ? _c('v-img', {
      attrs: {
        "src": _vm.resizedLogoPicture
      }
    }) : _c('v-icon', [_vm._v("face")])], 1), _vm._v(" "), (_vm.logoPicture) ? _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Your logo")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to change")])], 1) : _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("No logo")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Click to upload")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("upload")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
      attrs: {
        "width": "400"
      },
      model: {
        value: (_vm.uploadLogo),
        callback: function($$v) {
          _vm.uploadLogo = $$v
        },
        expression: "uploadLogo"
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "overline py-0 mb-0 grey lighten-4"
    }, [_vm._v("\n              Upload a logo\n              "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "small": "",
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.uploadLogo = false
        }
      }
    }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('uploader', {
      attrs: {
        "upload-path": _vm.logoUploadPath,
        "title": "Upload a logo",
        "subtitle": "The logo should be a rectangle (for best results) and it will be used on your invoices and free website.",
        "filename": "logo_picture"
      },
      on: {
        "uploadsuccess": _vm.get
      }
    })], 1)], 1)], _vm._v(" "), (_vm.settings) ? _c('object-form', {
      attrs: {
        "field-configs": _vm.config,
        "fields": _vm.fields
      },
      on: {
        "valid": _vm.setValid
      },
      model: {
        value: (_vm.settings),
        callback: function($$v) {
          _vm.settings = $$v
        },
        expression: "settings"
      }
    }, [_c('v-checkbox', {
      attrs: {
        "slot": "include_booking_info",
        "hint": "A link to your website is added to the bottom of invoices",
        "persistent-hint": "",
        "label": "Show online booking details"
      },
      slot: "include_booking_info",
      model: {
        value: (_vm.settings.include_booking_info),
        callback: function($$v) {
          _vm.$set(_vm.settings, "include_booking_info", $$v)
        },
        expression: "settings.include_booking_info"
      }
    }), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "slot": "integrate_medical_aid",
        "hint": "If checked, then we'll show medical aid information on invoices",
        "persistent-hint": "",
        "label": "Include medical information"
      },
      slot: "integrate_medical_aid",
      model: {
        value: (_vm.settings.integrate_medical_aid),
        callback: function($$v) {
          _vm.$set(_vm.settings, "integrate_medical_aid", $$v)
        },
        expression: "settings.integrate_medical_aid"
      }
    }), _vm._v(" "), _c('v-checkbox', {
      attrs: {
        "slot": "allow_submit_to_medical_aid",
        "hint": "Your clients can submit the invoice to medical aids at the click of a button!",
        "persistent-hint": "",
        "label": "Submit to medical aids"
      },
      slot: "allow_submit_to_medical_aid",
      model: {
        value: (_vm.settings.allow_submit_to_medical_aid),
        callback: function($$v) {
          _vm.$set(_vm.settings, "allow_submit_to_medical_aid", $$v)
        },
        expression: "settings.allow_submit_to_medical_aid"
      }
    })], 1) : _vm._e()
  ], 2) : _vm._e(), _vm._v(" "), _c('v-card-actions', [(_vm.withClose) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Close")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.saveReq.loading,
      "disabled": !_vm.isValid || _vm.getReq.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41918427","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/manage/InvoiceSettings.vue
// module id = 1404
// module chunks = 9